import React, { useEffect, useState } from "react";
import BreadcrumbItem from "../../shared/components/BreadcrumbItem";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { IGroup } from "../../shared/interfaces/group/IGroup";
import { GroupService } from "./service";
import { handleError } from "../../shared/functions/handleError";
import { usePagination } from "../../shared/hooks/usePagination";
import GroupList from "./components/List";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { IPagination } from "../../shared/interfaces/shared/IPagination";

const Groups = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [groups, setGroups] = useState<IGroup[]>([]);

    const {
        pagination,
        setPagination,
        changeFilterHandler,
        handleUpdateList,
        totalPages,
        setTotalPages,
    } = usePagination({
        perPage: 10,
    });

    const [localPagination, setLocalPagination] = useState<IPagination | null>(
        null,
    );

    const changeLocalPaginationHandler = (
        name: string,
        value: string | number | boolean | number[] | null,
    ) => {
        setLocalPagination((prev) => ({ ...prev, [name]: value }) as IPagination);
    };

    useEffect(() => {
        GroupService.getAll(pagination)
            .then((response) => {
                setGroups(response?.data);
                setTotalPages(response?.totalPages);
            })
            .catch(handleError);
    }, [pagination, setTotalPages]);

    return (
        <React.Fragment>
            <BreadcrumbItem
                mainTitle={t("group.groups")}
                subTitle={t("group.groupList")}
                buttonTitle={t("group.addGroup")}
                onCtaClick={() => navigate("/groups/create")}
            />
            <Card>
                <Card.Header>
                    <h5>{t("group.filterGroups")}</h5>
                </Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={4}>
                            <Form.Control
                                placeholder={t("group.searchByName")}
                                name={"name"}
                                value={localPagination?.name ?? ""}
                                onChange={(e) =>
                                    changeLocalPaginationHandler(e.target.name, e.target.value)
                                }
                                className={"w-100"}
                            />
                        </Col>
                        <Col md={4}>
                            <Form.Control
                                placeholder={t("group.searchByUserName")}
                                name={"userName"}
                                value={(localPagination as any)?.userName ?? ""}
                                onChange={(e) =>
                                    changeLocalPaginationHandler(e.target.name, e.target.value)
                                }
                                className={"w-100"}
                            />
                        </Col>
                        <Col md={4}>
                            <Form.Control
                                placeholder={t("group.searchByInstitutionName")}
                                name={"institutionName"}
                                value={localPagination?.institutionName ?? ""}
                                onChange={(e) =>
                                    changeLocalPaginationHandler(e.target.name, e.target.value)
                                }
                                className={"w-100"}
                            />
                        </Col>
                    </Row>
                </Card.Body>
                <Card.Footer className={"text-end"}>
                    <Button
                        variant={"light"}
                        onClick={() => {
                            setLocalPagination(null);
                            setPagination({ page: 0, size: 20 });
                        }}
                    >
                        {t("button.reset")}
                    </Button>
                    <Button
                        variant={"primary"}
                        className={"ms-3"}
                        onClick={() => {
                            setPagination((prev: IPagination) => ({
                                ...prev,
                                ...localPagination,
                            }));
                        }}
                    >
                        {t("button.search")}
                    </Button>
                </Card.Footer>
            </Card>
            <Card className="table-card">
                <Card.Header>
                    <h5>{t("group.groupList")}</h5>
                </Card.Header>
                <Card.Body className="pt-3">
                    <GroupList
                        groups={groups}
                        pagination={pagination}
                        totalPages={totalPages}
                        handleUpdateList={handleUpdateList}
                        changeFilterHandler={changeFilterHandler}
                    />
                </Card.Body>
            </Card>
        </React.Fragment>
    );
};

export default Groups;
